import apiCall from "@/libs/api";

export type APIDataSpaceVideoWithSpace = APIDataSpacesVideo & {
  space: APIDataSpacePublic;
};

export type APIDataPublishedSpaceVideo = APIDataSpacesVideo & {
  space: APIDataSpacePublic;
};

export const getSpaceTitle = (space: APIDataSpacePublic) => {
  return space.name || space.ref;
};

export const loadAccessibleSpaceVideos = async (
  locale: UILocale,
): Promise<APIDataSpaceVideoWithSpace[]> => {
  const spacesResponse = await apiCall("hub/spaces/getSpaces", { locale });

  if (!("spaces" in spacesResponse)) return [];

  const videosBySpace = await Promise.all(
    spacesResponse.spaces.map(async (space) => {
      const response = await apiCall("hub/spaces/videos", {
        action: "list",
        spaceUid: space.uid,
        locale,
        status: "available",
        publicationStatus: "published",
      });

      if (!("videos" in response)) return [];

      return response.videos.map((video) => ({
        ...video,
        space: {
          ...video.space,
          ref: space.uid,
          name: space.nameAlias || space.name,
          publicName: space.publicName || space.nameAlias || space.name,
          publicNames: space.publicNames,
          publicAvatar: space.publicAvatar,
          avatar: space.avatar,
          initials: space.initials,
        },
      }));
    }),
  );

  return videosBySpace
    .flat()
    .sort(
      (a, b) => new Date(b.created).getTime() - new Date(a.created).getTime(),
    );
};

export const loadPublishedSpaceVideos = async (
  locale: UILocale,
): Promise<APIDataPublishedSpaceVideo[]> => {
  const response = await apiCall("hub/spaces/videos", {
    action: "publicList",
    locale,
  });

  if (!("videos" in response)) return [];

  return response.videos.sort(
    (a, b) => new Date(b.created).getTime() - new Date(a.created).getTime(),
  );
};
